import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const PortalFooter: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ backgroundColor: '#1a1a2e', py: 5, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2, mb: 2 }}>
          <Typography sx={{ color: 'rgba(255,255,255,0.5)', fontSize: '0.875rem' }}>
            © 2026{' '}
            <Box component="span" sx={{ color: 'rgba(255,255,255,0.8)', fontWeight: 600 }}>
              callcenter-<Box component="span" sx={{ color: '#E85D26' }}>suche</Box>
            </Box>
            . Alle Rechte vorbehalten.
          </Typography>

          <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap', justifyContent: 'center' }}>
            {[
              { label: 'Für Dienstleister', path: '/dienstleister' },
              { label: 'Impressum', path: '/imprint' },
              { label: 'Datenschutz', path: '/privacy' },
              { label: 'AGB', path: '/terms' },
              { label: 'Kontakt', path: '/contact' },
            ].map((item) => (
              <Link
                key={item.path}
                component="button"
                variant="body2"
                onClick={() => { navigate(item.path); window.scrollTo(0, 0); }}
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: 'rgba(255,255,255,0.45)',
                  fontSize: '0.85rem',
                  transition: 'color 0.2s',
                  '&:hover': { color: '#E85D26', textDecoration: 'none' },
                }}
              >
                {item.label}
              </Link>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default PortalFooter;
